/**
 * USD display-only helpers. Use at render time; do not replace SSOT or business totals.
 * Integer USD, always rounded up (ceil), no fractional digits in UI.
 */

export function ceilUsd(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.ceil(num);
}

/**
 * Formatted integer USD for UI (grouping only; value is ceiled first).
 * @param {number|string|null|undefined} value
 * @param {string} [locale="en-US"]
 */
export function formatUsdDisplayInteger(value, locale = "en-US") {
  const n = ceilUsd(value);
  return n.toLocaleString(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}
